import * as React from "react";
const SvgArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m6 .667-.94.94 3.72 3.726H.667v1.334H8.78l-3.72 3.726.94.94 4.862-4.862a.667.667 0 0 0 0-.942L6 .667Z", fill: "#820AD1" }));
export default SvgArrow;
